import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-340fd53f")

_pushScopeId("data-v-340fd53f")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "clearfix" }, [
  /*#__PURE__*/_createVNode("span", null, "About me")
], -1)
const _hoisted_2 = { class: "user-profile" }
const _hoisted_3 = { class: "box-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, "Hello", -1)
const _hoisted_5 = { class: "box-center" }
const _hoisted_6 = { class: "user-name text-center" }
const _hoisted_7 = { class: "user-role text-center text-muted" }
const _hoisted_8 = { class: "user-bio" }
const _hoisted_9 = { class: "user-education user-bio-section" }
const _hoisted_10 = { class: "user-bio-section-header" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "Education", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "user-bio-section-body" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-muted" }, " JS in Computer Science from the University of Technology ")
], -1)
const _hoisted_13 = { class: "user-skills user-bio-section" }
const _hoisted_14 = { class: "user-bio-section-header" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "Skills", -1)
const _hoisted_16 = { class: "user-bio-section-body" }
const _hoisted_17 = { class: "progress-item" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "Vue", -1)
const _hoisted_19 = { class: "progress-item" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "Typescript", -1)
const _hoisted_21 = { class: "progress-item" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "Css", -1)
const _hoisted_23 = { class: "progress-item" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", null, "ESLint", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PanThumb = _resolveComponent("PanThumb")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock(_component_el_card, { style: {"margin-bottom":"20px"} }, {
    header: _withId(() => [
      _hoisted_1
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_PanThumb, {
            image: _ctx.user.avatar,
            height: '100px',
            width: '100px',
            hoverable: false
          }, {
            default: _withId(() => [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.user.roles), 1)
            ]),
            _: 1
          }, 8, ["image"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.user.name), 1),
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.user.roles), 1)
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_svg_icon, { name: "education" }),
            _hoisted_11
          ]),
          _hoisted_12
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_svg_icon, { name: "skill" }),
            _hoisted_15
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_el_progress, { percentage: 51 })
            ]),
            _createVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_el_progress, { percentage: 45 })
            ]),
            _createVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_el_progress, { percentage: 4 })
            ]),
            _createVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_el_progress, {
                percentage: 100,
                status: "success"
              })
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
})